import { FontAwesomeIcon } from "./FontAwesomeIcon"
import { faLinkedin } from "@fortawesome/free-brands-svg-icons"

export const Linkedin = (props) => {
  return <FontAwesomeIcon faIcon={faLinkedin} {...props} />
}
